4 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons"  :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button :id="'doctorAdd'" @click="addCompany">新增</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">公司简称：</span>
                <el-input v-model="short_name" placeholder="公司简称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">公司全称：</span>
                <el-input v-model="company_name" placeholder="公司全称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状态：</span>
                <el-select
                    clearable
                    v-model="status" placeholder="请选择状态"  style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allStatus"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="sort" label="排序" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="80" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="short_name" label="公司简称" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column prop="company_name" label="公司全称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="region_name" label="所属区域" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="department_number" label="部门数量" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="180" prop="update_date" label="更新时间" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="status" label="置顶状态" align="center" label-class-name="label">
                <template slot-scope="scope">
                    {{scope.row.is_top==1? '已置顶':'未置顶' }}
                </template>
            </el-table-column>
            <el-table-column width="120" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button :id="'doctorEdit'" @click="deleteHealthrecords(scope.row)"
                           type="text" size="mini">删除
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopCompany(scope.row,2)"
                           v-if="scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopCompany(scope.row,1)"
                           v-if="scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button :id="'doctorEdit'" @click="getAllCompanyDeparment(scope.row)"
                           type="text" size="mini">部门
                </el-button>
                <el-button :id="'doctorEdit'" @click="addCompanyDeparment(scope.row)"
                           type="text" size="mini">添加部门
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {getUserInfos} from "@/utils/userInfos";
    import {authUrlCheck, isMobile} from "@/api/order";

    export default {
        data() {
            return {
                role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allStatus: [
                    {
                        id: 1,
                        name: '启用'
                    },
                    {
                        id: 2,
                        name: '停用'
                    },
                ],
                short_name: '',
                company_name: '',
                status: '',
                button_position: 'absolute',
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
            }
        },
        mounted() {
            // 获取公司列表
            this.getList();
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
            }
            localStorage.setItem('prev_page', 'company_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'companyListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        short_name: this.short_name,
                        company_name: this.company_name,
                        status: this.status,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                      res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 2;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.company_name = "";
                this.short_name = "";
                this.status = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "companyEdit", params: {
                        id: data.id,
                        company_name: data.company_name,
                        short_name: data.short_name,
                        is_top: data.is_top,
                        province_id: data.province_id,
                        city_id: data.city_id,
                        distinct_id: data.distinct_id,
                        status: parseInt(data.status_number),
                    }
                });
            },

            // 新增公司
            addCompany() {
                this.$router.push({name: "companyAdd", params: {}});
            },

            deleteHealthrecords(data) {
                this.$confirm('确定删除该公司吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'deleteCompany',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.getList();
                    });
                }).catch(() => {
                });
            },

            // 启用停用公司
            startStopCompany(data, status) {
                if (status == '1') {
                    var message = '确定启用该公司吗？';
                }
                if (status == '2') {
                    var message = '确定停用该公司吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'startStopCompany',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                    });
                }).catch(() => {
                });
            },

            // 跳转到下属部门
            getAllCompanyDeparment(data) {
                this.$router.push({
                    name: "deparmentList",
                    params: {
                        company_id: data.id
                    }
                });
            },

            // 跳转到添加部门
            addCompanyDeparment(data) {
                this.$router.push({
                    name: "deparmentAdd", params: {
                        company_id: data.id
                    }
                });
            },

            // 导出数据
            exportExcel() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'exportCompany',
                    params: {
                        sort: this.sort,
                        short_name: this.short_name,
                        company_name: this.company_name,
                        region_name: this.region_name,
                        department_number: this.department_number,
                        update_date: this.update_date,
                        status: this.status,
                    },
                };
                let colums_list = [
                    {title: "排序", key: "sort"},
                    {title: "公司简称", key: "short_name"},
                    {title: "公司全称", key: "company_name"},
                    {title: "所属区域", key: "region_name"},
                    {title: "部门数量", key: "department_number"},
                    {title: "更新时间", key: "update_date"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        return false;
                    }

                    for (let i = 0; i < res_data.data.length; i++) {
                        let status;
                        let is_expired;
                        switch (res_data.data[i].status) {
                            case '1':
                                status = '启用';
                                break;
                            case '2':
                                status = '停用';
                                break;
                        }

                        let item = {
                            sort: res_data.data[i].sort,
                            short_name: res_data.data[i].short_name,
                            company_name: res_data.data[i].company_name,
                            region_name: res_data.data[i].region_name,
                            department_number: res_data.data[i].department_number,
                            update_date: res_data.data[i].update_date,
                            status: status,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出公司");
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-input {width: 100% !important;}
</style>
